import { render } from "./CommentIcon.vue?vue&type=template&id=cf260232"
const script = {}
script.render = render

export default script